import {Tab, TabList, TabPanel, Tabs} from 'react-tabs'
import User from '../../Views/UserWrapper/form/user'
import {TablePermissionByUserWrapper} from './component/table/permissionByUser'
import {TabCentralModel} from '../../../../../models'
import ButtonClose from '../../../../../components/UI/Button/IconButton'
import {useCentral} from '../../../../../hooks/useCentral'
import {ResetPassword} from './component/table/ResetPassword'
const UserTab = () => {
  const {currentTabItem, changeCurrentTabItem, isAllowed} = useCentral()

  const handleBack = () => {
    const obj: TabCentralModel = {
      ...currentTabItem,
      showPanel: false,
    }
    // reset()
    changeCurrentTabItem(obj)
  }
  let isDisabled = currentTabItem.idToEdit ? true : false
  return (
    <div className='sdx_content_tab_panel'>
      {isDisabled && <ButtonClose onClick={handleBack} color='#283897' />}

      <Tabs className={'sdx_sub_react_tab_panel '}>
        <TabList className={'sdx_sub_tab_panel p-0'}>
          <Tab className={'sdx_sub_tab_panel_option'}>Actualizar Registro</Tab>
          {isAllowed('PERMISO/ACCESO') && (
            <Tab className={'sdx_sub_tab_panel_option'}>Permisos</Tab>
          )}
          {isAllowed('RESETCONTRASEÑA/ACCESO') && (
            <Tab className={'sdx_sub_tab_panel_option'}>Resetear Constraseña</Tab>
          )}
        </TabList>
        <TabPanel>
          <User />
        </TabPanel>
        {isAllowed('PERMISO/ACCESO') && (
          <TabPanel>
            <TablePermissionByUserWrapper />
          </TabPanel>
        )}
        {isAllowed('RESETCONTRASEÑA/ACCESO') && (
          <TabPanel>
            <ResetPassword />
          </TabPanel>
        )}
      </Tabs>
    </div>
  )
}

export default UserTab
